import { GetMyChats_getMyChats } from './__generated__/GetMyChats';

export type Conversation = GetMyChats_getMyChats;

export const ASSISTANT_FEATURE_FLAG = 'featureTeacherAssistant';
